<template>
  <div id="app">
      <Loader v-show="$store.state.loading"/>
      <router-view/>
  </div>
</template>

<script>
    import jquery from 'jquery';
    window.$ = window.jQuery = jquery;
    import Loader from './partials/Loader'

    export default {
        name: 'App',
        components: {
            Loader
        },
        methods: {
            handleStyles () {
                if (['/login'].includes(this.$route.path)) document.body.className = 'login';
            },
        },
        mounted () {
            this.handleStyles();
        },
        watch: {
            '$route' () {
                this.handleStyles()
            }
        },
}
</script>
<style>
    @import "./assets/css/bootstrap.css";
</style>